import {HttpModelConverter} from "../../../../../core/converter/httpModel.converter";
import {Injectable} from "@angular/core";
import {FormDefinitionFormSummaryConverter} from "../../../../../form/definition/form/api/entity/converter/formDefinitionFormSummary.converter";
import {OnlineFormFormDefinitionSummaryModel} from "../onlineFormFormDefinitionSummary.model";

@Injectable({
    providedIn: 'root'
})
export class OnlineFormFormDefinitionSummaryConverter extends HttpModelConverter<OnlineFormFormDefinitionSummaryModel> {

    protected createInstance(): OnlineFormFormDefinitionSummaryModel {
        return new OnlineFormFormDefinitionSummaryModel();
    }

    protected enrichObject(result: OnlineFormFormDefinitionSummaryModel, src: OnlineFormFormDefinitionSummaryModel) {
        result.formDefinition = new FormDefinitionFormSummaryConverter().convert(src.formDefinition);
    }


}